import { render, staticRenderFns } from "./WidgetCategoryHorse.vue?vue&type=template&id=1ecc31f6&"
import script from "./WidgetCategoryHorse.vue?vue&type=script&lang=js&"
export * from "./WidgetCategoryHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports